import { ActionTypes } from '../actions/types';
import {
  ConfigModel,
  configParamsToConfigModel,
} from '../../models/ConfigModel';
import { cloneDeep } from 'lodash';

export const getInitialConfigModel = () => {
  const model = cloneDeep(initialState);
  model.loaded = true;
  return model;
};

const initialState: ConfigModel = {
  isAdresseEinmaladresseEdit: false,
  isAdresseKontaktEdit: false,
  isAdresseTelefonEdit: false,
  isAdresseUnsichtbarEdit: true,
  loaded: false,
  dokumentenverweise: false,
  isBexPremium: false,
  isBreitePflichtfeld: false,
  isHoehePflichtfeld: false,
  isLaengePflichtfeld: false,
  isVerkehrsartPflichtfeld: false,
  isStellplaetzeBerechnen: true,
  isLademeterBerechnen: true,
  isPreisermittlung: false,
  isUserCanEditImmediately: false,
  isZusaetzlicheLademittel: false,
  mandantSpezi29: false,
  isBeladedatumVorbelegen: false,
  isEntladedatumVorbelegen: false,
  isServicesInternSendungen: false,
  ttInhalt: true,
  ttEmpfaengerFremdnummer: true,
  ttEmpfaengerMatchcode: true,
  ttEmpfaengerStrasse: true,
  ttVersenderFremdnummer: true,
  ttVersenderMatchcode: true,
  ttVersenderName: true,
  ttVersenderOrt: true,
  ttVersenderStrasse: true,
  isShowTTMailAdress: false,
  clientMinLengthPw: undefined,
  denyOrderEdit: false,
  isShowKlassifizierung: false,
  isShowAbsenderNeutral: false, //neuer config_param
  isNoADRVerpackungen: false,
  isNoADRLademittel: false,
  isDenyZustelldatum: false,
  terminArtFixTermin: undefined,
  isAbsenderEditDeny: false,
  isTTSwitchAbsenderToNeutral: true,
  zustelldatum_offset: '1',
  zustelldatum_off: false,
  isDeleteDocumentsForbidden: false,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.SET_CLIENT_CONFIG_MODEL: {
      return payload;
    }
    case ActionTypes.SET_CLIENT_CONFIG: {
      return configParamsToConfigModel(payload);
    }
    case ActionTypes.SET_CONFIG_PARAM_FIELD: {
      const [value, fieldName] = [payload.value, payload.fieldName];

      return {
        ...state,
        [fieldName]: value,
      };
    }
    case ActionTypes.RESET_CLIENT_CONFIG: {
      return {
        ...state,
        ...initialState,
      };
    }
    default:
      return state;
  }
}
